import {
  INVALID_TOKEN_CODE,
  TERMS_NOT_ACCEPTED,
  INVALID_PASSWORD,
} from '../errorCodes';

import invalidTokenCode from './invalidTokenCode';
import termsNotAccepted from './termsNotAccepted';
import invalidPassword from './invalidPassword';

export const onErrorMap = new Map([
  [INVALID_TOKEN_CODE, invalidTokenCode],
  [TERMS_NOT_ACCEPTED, termsNotAccepted],
  [INVALID_PASSWORD, invalidPassword],
]);
